import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/i18n";
import { api } from "@/lib/api";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "de");
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=auth
  const [siteInfo, setSiteInfo] = useState({});
  const [services, setServices] = useState({});

  const t = translations[lang] || translations.de;

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const tx = useCallback((v, fb = "") => {
    if (v == null) return fb;
    if (typeof v === "string") return v || fb;
    return v[lang] || v.de || fb;
  }, [lang]);

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("lang", l);
  }, []);

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refreshMe();
    api.get("/site-info").then(({ data }) => setSiteInfo(data || {})).catch(() => {});
    api.get("/services").then(({ data }) => setServices(data || {})).catch(() => {});
  }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  return (
    <AppContext.Provider value={{ lang, changeLang, t, tx, user, setUser, login, logout, refreshMe, siteInfo, services }}>
      {children}
    </AppContext.Provider>
  );
}
